import { render, staticRenderFns } from "./ReviewCostInfo.vue?vue&type=template&id=55bf13d8&scoped=true&"
import script from "./ReviewCostInfo.vue?vue&type=script&lang=js&"
export * from "./ReviewCostInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCostInfo.vue?vue&type=style&index=0&id=55bf13d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bf13d8",
  null
  
)

export default component.exports